import { dashboard_vertical_three_dots } from "../../../assets/images";

import { Link, useNavigate } from "react-router-dom";
import "./styles.css";
import { useState } from "react";

import { Dropdown, Pagination } from "react-bootstrap";
import { API_URL } from "../../../services/apiConfig";
import axiosInstance from "../../../services/axios.instance";
import { useQuery } from "@tanstack/react-query";
import { BookedOrderApiResponse, BookedOrder } from "../../../types";
import { ArrowLeft } from "react-bootstrap-icons";

const RentDeals = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const navigate = useNavigate();
  const generatePageNumbers = (currentPage: number, totalPages: number) => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i);
    }

    if (currentPage <= 3) {
      return [0, 1, 2, 3, -1, totalPages - 2, totalPages - 1];
    }

    if (currentPage >= totalPages - 4) {
      return [0, 1, -1, totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1];
    }

    return [0, 1, -1, currentPage - 1, currentPage, currentPage + 1, -1, totalPages - 1];
  };
  const fetchBookedOrders = async (page: number) => {
    const response = await axiosInstance.get(
      `${API_URL.BOOKED_ORDERS}?page=${page}&size=10`,
      {
        headers: {
          location: "0,0",
          language: "english",
        },
      }
    );
    return response?.data;
  };
  const { data: BookedOrders } = useQuery<BookedOrderApiResponse>({
    queryKey: ["BookedOrders", currentPage],
    queryFn: () => fetchBookedOrders(currentPage),
    refetchInterval: 30000,
  });

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const formatDate = (isoDate: any) => {
    const date = new Date(isoDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    // return `${year}-${month}-${day}`;
    return `${day}-${month}-${year}`;
  };

  //const currentItems = tableData.slice(indexOfFirstItem, indexOfLastItem);

  const getStatusClass = (status: string) => {
    if (status === "ORDER_ACCEPT" || status === "MERCHANT_ORDER_ACCEPT") return "status-accepted";
    if (status === "BOOKED" || status === "MERCHANT_ORDER_REJECTED") return "status-booked";
    if (status === "DELIVERED") return "status-delivered";
    if (status === "ORDER_REJECTED") return "status-rejected";
    return "status-default";
  };

  return (
    <div className="row g-4">
      {/* Desktop View */}
      <div className="col-md-12 dashboard-table-div d-none d-md-block">
        <table className="table table-hover dashboard-table">
          <thead>
            <tr>
              <th>Order Number</th>
              <th>Rental Days</th>
              <th>Progress</th>
              <th>Product Name</th>
              <th>Purchase Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {BookedOrders?.content && BookedOrders.content.length > 0 ? (
              BookedOrders?.content?.map((bookedorder: BookedOrder, index: number) => (
                <tr key={index}>
                  <td>{bookedorder?.orderId}</td>
                  <td>{(bookedorder?.rental_days ?? 0)}</td>
                  <td>
                    <span className={`status-badge ${getStatusClass(bookedorder?.orderStatus)}`}>
                      {bookedorder?.orderStatus === "ORDER_ACCEPT" || bookedorder?.orderStatus === "MERCHANT_ORDER_ACCEPT"
                        ? "ORDER ACCEPTED"
                        : bookedorder?.orderStatus === "MERCHANT_ORDER_REJECTED"
                          ? "BOOKED"
                          : bookedorder?.orderStatus}
                    </span>
                  </td>
                  <td>{bookedorder?.products?.[0]?.productName}</td>
                  <td>
                    <span className="invoice-date-td">
                      {formatDate(bookedorder?.createdAt)}
                    </span>
                  </td>
                  <td>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="success"
                        id="dropdown-basic"
                        className="Dropdown-table"
                      >
                        <img
                          alt="options"
                          src={dashboard_vertical_three_dots}
                          width="15"
                          height="15"
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="Dropdown-table-item">
                        <Dropdown.Item className="Dropdown-table-list">
                          <Link
                            to={`/customer/rentdealsdetails?OrderId=${bookedorder.orderId}`}
                            className="nav-link Dropdown-table-item-link"
                          >
                            View Details
                          </Link>
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6}>
                  <div className="dashboard-empty-state">
                    <div className="empty-state-icon">
                      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                    </div>
                    <h3 className="empty-state-title">No Active Deals</h3>
                    <p className="empty-state-text">You haven't rented any cars yet. Browse our collection to find your perfect ride!</p>
                    <button className="empty-state-btn" onClick={() => navigate("/customer/myaccount")}>Browse Cars</button>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Mobile View */}
      <div className="col-12 d-block d-md-none">
        {BookedOrders?.content && BookedOrders.content.length > 0 ? (
          BookedOrders?.content?.map((bookedorder: BookedOrder, index: number) => (
            <div key={index} className="card customer-orders-mobile-card">
              <div className="mobile-card-header">
                <span className="mobile-order-id">Order ID: {bookedorder?.orderId}</span>
                <span className={`status-badge ${getStatusClass(bookedorder?.orderStatus)}`}>
                  {bookedorder?.orderStatus === "ORDER_ACCEPT" || bookedorder?.orderStatus === "MERCHANT_ORDER_ACCEPT" ? "ACCEPTED" : bookedorder?.orderStatus === "MERCHANT_ORDER_REJECTED" ? "BOOKED" : bookedorder?.orderStatus}
                </span>
              </div>
              <div className="mobile-card-body">
                <div className="mobile-info-grid">
                  <span className="mobile-info-label">Rental Days</span>
                  <span className="mobile-info-value">
                    {(bookedorder?.rental_days ?? 0) + (bookedorder?.extended_rental_days ?? 0)}
                  </span>
                  
                  <span className="mobile-info-label">Product</span>
                  <span className="mobile-info-value">{bookedorder?.products?.[0]?.productName}</span>
                  
                  <span className="mobile-info-label">Purchased</span>
                  <span className="mobile-info-value">{formatDate(bookedorder?.createdAt)}</span>
                </div>
                
                <div className="mobile-card-actions">
                  <Link
                    to={`/customer/rentdealsdetails?OrderId=${bookedorder.orderId}`}
                    className="mobile-action-btn btn-view-details w-100"
                  >
                    View Details
                  </Link>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="dashboard-empty-state">
            <div className="empty-state-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
            </div>
            <h3 className="empty-state-title">No Active Deals</h3>
            <button className="empty-state-btn mt-3" onClick={() => navigate("/customer/myaccount")}>Browse Cars</button>
          </div>
        )}
      </div>

      {/* Pagination */}
      {BookedOrders && BookedOrders.totalPages > 1 && (
        <div className="col-12 mt-4">
          <Pagination className="pagination-align">
            <Pagination.Prev
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 0}
            />
            {generatePageNumbers(currentPage, BookedOrders.totalPages).map((pageNum, index) => (
              pageNum === -1 ? (
                <Pagination.Ellipsis key={`ellipsis_${index}`} />
              ) : (
                <Pagination.Item
                  key={pageNum}
                  active={pageNum === currentPage}
                  onClick={() => handlePageChange(pageNum)}
                >
                  {pageNum + 1}
                </Pagination.Item>
              )
            ))}
            <Pagination.Next
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === BookedOrders.totalPages - 1}
            />
          </Pagination>
        </div>
      )}
    </div>
  );
};

export default RentDeals;
